import { render, staticRenderFns } from "./ShippingLeadsList.vue?vue&type=template&id=3af36db1&scoped=true&"
import script from "./ShippingLeadsList.vue?vue&type=script&lang=js&"
export * from "./ShippingLeadsList.vue?vue&type=script&lang=js&"
import style0 from "./ShippingLeadsList.vue?vue&type=style&index=0&id=3af36db1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af36db1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/data/jenkins/workspace/booking-fe-stg/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3af36db1')) {
      api.createRecord('3af36db1', component.options)
    } else {
      api.reload('3af36db1', component.options)
    }
    module.hot.accept("./ShippingLeadsList.vue?vue&type=template&id=3af36db1&scoped=true&", function () {
      api.rerender('3af36db1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Home/ShippingLeadsList.vue"
export default component.exports